module.exports = __webpack_public_path__ + "static/media/logo.48144184.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 171
// module chunks = 7